"use client";

import { useEffect, useState } from "react";
import { extractInfoFromUrl, getStorage, setStorage } from "../../lib/util";

export const useProductPriceDisplay = (accessPoint, product) => {
  const storeFrontDisplayPrice = accessPoint?.settings?.storeFrontDisplayPrice;
  const [priceDisplayMode, setPriceDisplayMode] = useState(() => {
    const saved = getStorage("priceDisplayMode");
    if (saved) return saved;

    if (storeFrontDisplayPrice) {
      switch (storeFrontDisplayPrice) {
        case "DISCOUNT":
          return "d";
        case "PROMO":
          return "p";
        case "MARKUP":
          return "m";
        case "NORMAL":
          return "s";
        default:
          return null;
      }
    }

    return null;
  });

  useEffect(() => {
    let urlMode = extractInfoFromUrl("p");
    const storedMode = getStorage("priceDisplayMode");
    let mode;

    if (urlMode) {
      if (urlMode.length > 1) {
        urlMode = urlMode.charAt(0);
      }
      mode = urlMode;
      setStorage("priceDisplayMode", urlMode);
    } else if (storedMode) {
      mode = storedMode;
    }
    setPriceDisplayMode(mode);
  }, []);

  const getDisplayPrice = (product) => {
    switch (priceDisplayMode) {
      case "d":
        return product.discountPrice ?? product.amount;
      case "p":
        return product.promoPrice ?? product.amount;
      case "m":
        return product.markUpPrice ?? product.amount;
      case "s" || null:
      default:
        return product.amount;
    }
  };
  const productPrice = getDisplayPrice(product);

  const selectedPricePayload = {
    usePromo: priceDisplayMode === "p",
    useDiscount: priceDisplayMode === "d",
    useMarkup: priceDisplayMode === "m",
  };
  
  return {
    getDisplayPrice,
    productPrice,
    selectedPricePayload,
  };
};
